var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qipao", style: { left: _vm.left, top: _vm.top } },
    [
      _c("div", { staticClass: "qipao_item" }, [
        _c("div", { staticClass: "paopao" }, [
          _c(
            "div",
            {
              staticClass: "qipao-main",
              on: {
                mouseover: _vm.mouseover,
                mouseout: _vm.mouseout,
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.click($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.floorIndex)), _c("br"), _vm._v(_vm._s(_vm.num))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "qipao-line" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "map-point-di-animate",
            class: {
              "map-point-di-animate-active": _vm.animate,
              "map-point-di-animate-init": !_vm.animate,
              "map-point-di-animate-middle": _vm.type === "middle"
            }
          },
          [_c("div", { staticClass: "point" }), _vm._v(" "), _vm._m(0)]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "waiquan" }, [
      _c("div", { staticClass: "waiquan" }, [
        _c("div", { staticClass: "neiquan" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08edd203", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08edd203","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/floor_distribution/qipao.vue
// module id = null
// module chunks = 